export default {
  projectTypeList(state){
    return state.projectTypeList;
  }
};
